
var graph = require('@microsoft/microsoft-graph-client');

function getAuthenticatedClient(accessToken: string) {
    // Initialize Graph client
    const client = graph.Client.init({
        // Use the provided access token to authenticate
        // requests
        authProvider: (done: any) => {
            done(null, accessToken);
        }
    });

    return client;
}

export async function getUserDetails(accessToken: string) {

    const client = getAuthenticatedClient(accessToken);

    const user = await client.api('/me').get();
    return user;
}


export async function getGroups(accessToken: string) {

    const client = getAuthenticatedClient(accessToken);

    //const pload = {
    //    securityEnabledOnly: true
    //};

    const groups = await client
        .api('/me/memberOf?$top=999').get();

    return groups;
}

